export const shikshapatriMukhpathData = [
  {
    number: 14,
    sanskrit:
      "आत्मघातस्तु तीर्थेऽपि न कर्तव्यश्च न क्रुधा ।<br>अयोग्याचरणात्‌ क्वापि न विषोद्बन्धनादिना ।।१४।।",
    gujarati:
      "અને આત્મઘાત તો તીર્થને વિષે પણ ન કરવો ને ક્રોધે કરીને ન કરવો અને કયારેક કોઈ અયોગ્ય આચરણ થઈ જાય તે થકી મૂંઝાઈને પણ આત્મઘાત ન કરવો અને ઝેર ખાઈને તથા ગળે ટૂંપો ખાઈને તથા કૂવે પડીને તથા પર્વત ઉપરથી પડીને ઈત્યાદિક કોઈ રીતે આત્મઘાત ન કરવો. ।।૧૪।।",
  },
  {
    number: 15,
    sanskrit:
      "न भक्ष्यं सर्वथा मांसं यज्ञशिष्टमपि क्वचित्‌ ।<br>न पेयं च सुरामद्यमपि देवनिवेदितम्‌ ।।१५।।",
    gujarati:
      "અને જે માંસ છે તે તો યજ્ઞનું શેષ હોય તો પણ આપત્કાળમાં પણ કયારેય ન ખાવું અને ત્રણ પ્રકારની સુરા અને અગિયાર પ્રકારનું મદ્ય તે દેવતાનું નૈવેદ્ય હોય તો પણ ન પીવું. ।।૧૫।।",
  },
  {
    number: 16,
    sanskrit:
      "अकार्याचरणे क्वापि जाते स्वस्य परस्य वा ।<br>अङ्गच्छेदो न कर्तव्य: शस्त्राद्यैश्च क्रुधाऽपि वा ।।१६।।",
    gujarati:
      "અને કયારેક પોતાવતે કાંઈક અયોગ્ય આચરણ થઈ ગયું હોય અથવા કોઈ બીજા વતે અયોગ્ય આચરણ થઈ ગયું હોય તો શસ્ત્રાદિકે કરીને પોતાના અંગનું તથા બીજાના અંગનું છેદન ન કરવું અથવા ક્રોધે કરીને પણ પોતાના અંગનું તથા બીજાના અંગનું છેદન ન કરવું. ।।૧૬।।",
  },
  {
    number: 17,
    sanskrit:
      "स्तेनकर्म न कर्तव्यं धर्मार्थमपि केनचित्‌ ।<br>सस्वामिकाष्ठपुष्पादि न ग्राह्यं तदनाज्ञया ।।१७।।",
    gujarati:
      "અને ધર્મ કરવાને અર્થે પણ અમારા સત્સંગી, કોઈએ ચોરનું કર્મ ન કરવું અને ધણિયાતું જે કાષ્ઠ, પુષ્પ આદિક વસ્તુ, તે તેના ધણીની આજ્ઞા વિના ન લેવું. ।।૧૭।।",
  },
  {
    number: 18,
    sanskrit:
      "व्यभिचारो न कर्तव्य: पुम्भि: स्त्रीभिश्च मां श्रितै: ।<br>द्यूतादिव्यसनं त्याज्यं नाद्यं भङ्गादिमादकम्‌ ।।१८।।",
    gujarati:
      "અને અમારા આશ્રિત જે પુરુષ તથા સ્ત્રીઓ તેમણે વ્યભિચાર ન કરવો અને જુગટું આદિક જે વ્યસન તેનો ત્યાગ કરવો અને ભાંગ, મફર, માજમ, ગાંજો એ આદિક જે કેફ કરનાર વસ્તુ, તે ખાવી નહિ અને પીવી પણ નહિ. ।।૧૮।।",
  },
  {
    number: 20,
    sanskrit:
      "मिथ्यापवाद: कस्मिंश्चिदपि स्वार्थस्य सिद्धये ।<br>नारोप्यो नापशब्दाश्च भाषणीया: कदाचन ।।२०।।",
    gujarati:
      "અને પોતાના સ્વાર્થની સિદ્ધિને અર્થે પણ કોઈને વિષે મિથ્યા અપવાદ આરોપણ ન કરવો અને કોઈને ગાળ તો કયારેય ન દેવી. ।।૨૦।।",
  },
  {
    number: 21,
    sanskrit:
      "देवतातीर्थविप्राणां  साध्वीनां  च  सतामपि ।<br>वेदानां च न कर्तव्या निन्दा श्रव्या न च क्वचित्‌ ।।२१।।",
    gujarati:
      "અને દેવતા, તીર્થ, બ્રાહ્મણ, પતિવ્રતા, સાધુ અને વેદ એમની નિંદા કયારેય ન કરવી અને ન સાંભળવી. ।।૨૧।।",
  },
  {
    number: 23,
    sanskrit:
      "दृष्ट्‌वा शिवालयादीनि देवागाराणि वर्त्मनि ।<br>प्रणम्य तानि तद्देवदर्शनं कार्यमादरात्‌ ।।२३।।",
    gujarati:
      "અને માર્ગને વિષે ચાલતે શિવાલયાદિક જે દેવમંદિર આવે તેને જોઈને તેને નમસ્કાર કરવા અને આદરથકી તે દેવનું દર્શન કરવું. ।।૨૩।।",
  },
  {
    number: 25,
    sanskrit:
      "कृष्णभक्ते: स्वधर्माद्वा पतनं यस्य वाक्यत: ।<br>स्यात्तन्मुखान्न वै श्रव्या: कथावार्ताश्च वा प्रभो: ।।२५।।",
    gujarati:
      "અને જેના વચનને સાંભળવે કરીને શ્રીકૃષ્ણ ભગવાનની ભક્તિ ને પોતાનો ધર્મ એ બે થકી પડી જવાય તેના મુખ થકી ભગવાનની કથાવાર્તા ન સાંભળવી. ।।૨૫।।",
  },
  {
    number: 26,
    sanskrit:
      "स्वपरद्रोहजननं  सत्यं  भाष्यं  न  कर्हिचित्‌ ।<br>कृतघ्नसङ्गस्त्यक्तव्यो लुञ्चा ग्राह्या न कस्यचित्‌ ।।२६।।",
    gujarati:
      "અને જે સત્ય વચન બોલવે કરીને  પોતાનો દ્રોહ થાય તથા પારકો દ્રોહ થાય એવું જે સત્ય વચન, તે કયારેય ન બોલવું અને જે કૃતઘ્ની હોય તેના સંગનો ત્યાગ કરવો અને વ્યવહારકાર્યને વિષે કોઈની લાંચ ન લેવી. ।।૨૬।।",
  },
  {
    number: 27,
    sanskrit:
      "चोरपापिव्यसनिनां सङ्ग: पाखण्डिनां तथा ।<br>कामिनां च न कर्तव्यो जनवञ्चनकर्मणाम्‌ ।।२७।।",
    gujarati:
      "અને ચોર, પાપી, વ્યસની, પાખંડી, કામી તથા કીમિયા આદિક ક્રિયાએ કરીને જનનો ઠગનારો, એ છ પ્રકારના જે મનુષ્ય તેમનો સંગ ન કરવો. ।।૨૭।।",
  },
  {
    number: 28,
    sanskrit:
      "भक्तिं वा ज्ञानमालम्ब्य स्त्रीद्रव्यरसलोलुभा: ।<br>पापे प्रवर्तमाना: स्यु: कार्यस्तेषां न सङ्गम: ।।२८।।",
    gujarati:
      "અને જે મનુષ્ય, ભક્તિનું અથવા જ્ઞાનનું આલંબન કરીને સ્ત્રી, દ્રવ્ય અને રસાસ્વાદ તેને વિષે અતિશય લોલુપ થકા પાપને વિષે પ્રવર્તતા હોય, તે મનુષ્યનો સમાગમ ન કરવો. ।।૨૮।।",
  },
  {
    number: 29,
    sanskrit:
      "कृष्णकृष्णावताराणां खण्डनं यत्र युक्तिभि: ।<br>कृतं स्यात्तानि शास्त्राणि न मान्यानि कदाचन ।।२९।।",
    gujarati:
      "અને જે શાસ્ત્રને વિષે શ્રીકૃષ્ણ ભગવાન તથા શ્રીકૃષ્ણ ભગવાનના જે વારાહાદિક અવતાર તેમનું યુક્તિએ કરીને ખંડન કર્યું હોય એવાં જે શાસ્ત્ર તે કયારેય ન માનવાં અને ન સાંભળવાં. ।।૨૯।।",
  },
  {
    number: 35,
    sanskrit:
      "अपमानो न कर्तव्यो गुरू णां च वरीयसाम्‌ ।<br>लोके प्रतिष्ठितानां च विदुषां शस्त्रधारिणाम्‌ ।।३५।।",
    gujarati:
      "અને ગુરુનું અપમાન ન કરવું તથા જે અતિશય શ્રેષ્ઠ મનુષ્ય હોય તથા જે લોકને વિષે પ્રતિષ્ઠિત મનુષ્ય હોય તથા જે વિદ્વાન મનુષ્ય હોય તથા જે શસ્ત્રધારી મનુષ્ય હોય તે સર્વેનું અપમાન ન કરવું. ।।૩૫।।",
  },
  {
    number: 36,
    sanskrit:
      "कार्यं न सहसा किञ्चित्कार्यो धर्मस्तु सत्वरम्‌ ।<br>पाठनीयाऽधीतविद्या कार्य: सङ्गोऽन्वहं सताम्‌ ।।३६।।",
    gujarati:
      "અને વિચાર્યા વિના તત્કાળ કાંઈ કાર્ય ન કરવું અને ધર્મ સંબંધી જે કાર્ય તે તો તત્કાળ કરવું અને  પોતે જે વિદ્યા ભણ્યા હોઈએ તે બીજાને ભણાવવી અને નિત્ય પ્રત્યે સાધુનો સમાગમ કરવો. ।।૩૬।।",
  },
  {
    number: 37,
    sanskrit:
      "गुरुदेवनृपेक्षार्थं  न  गम्यं  रिक्तपाणिभि: ।<br>विश्वासघातो नो कार्य:स्वश्लाघा स्वमुखेन च ।।३७।।",
    gujarati:
      "અને ગુરુ, દેવ અને રાજા એ ત્રણના દર્શનને અર્થે જ્યારે જવું ત્યારે ઠાલે હાથે ન જવું અને કોઈનો વિશ્વાસઘાત ન કરવો અને  પોતાને મુખે કરીને  પોતાનાં વખાણ ન કરવાં. ।।૩૭।।",
  },
  {
    number: 38,
    sanskrit:
      "यस्मिन्‌ परिहितेऽपि स्युर्दृश्यान्यङ्गानि चात्मन: ।<br>तद्दूष्यं वसनं नैव परिधार्यं मदाश्रितै: ।।३८।।",
    gujarati:
      "અને જે વસ્ત્ર પહેર્યે થકે પણ  પોતાનાં અંગ દેખાય તેવું જે ભૂંડું વસ્ત્ર તે અમારા સત્સંગી તેમણે ન પહેરવું. ।।૩૮।।",
  },
  {
    number: 39,
    sanskrit:
      "धर्मेण रहिता कृष्णभक्ति: कार्या न सर्वथा ।<br>अज्ञनिन्दाभयान्नैव त्याज्यं श्रीकृष्णसेवनम्‌ ।।३९।।",
    gujarati:
      "અને શ્રીકૃષ્ણ ભગવાનની જે ભક્તિ તે ધર્મે રહિત એવી કોઈ પ્રકારે ન કરવી અને અજ્ઞાની એવા જે મનુષ્ય તેમની નિંદાના ભય થકી શ્રીકૃષ્ણ ભગવાનની સેવાનો ત્યાગ કરવો જ નહિ. ।।૩૯।।",
  },
  {
    number: 40,
    sanskrit:
      "उत्सवाहेषु  नित्यं  च  कृष्णमन्दिरमागतै: ।<br>पुम्भि: स्पृश्या न वनितास्तत्र ताभिश्च पूरुषा: ।।४०।।",
    gujarati:
      "અને ઉત્સવના દિવસને વિષે तथा નિત્ય પ્રત્યે શ્રીકૃષ્ણના મંદિરમાં આવ્યા એવા જે સત્સંગી પુરુષ તેમણે તે મંદિરને વિષે સ્ત્રીઓનો સ્પર્શ ન કરવો તથા સ્ત્રીઓ તેમણે પુરુષનો સ્પર્શ ન કરવો અને મંદિરમાંથી નીસર્યા પછી  પોતપોતાની રીતે વર્તવું. ।।૪૦।।",
  },
  {
    number: 49,
    sanskrit:
      "प्रत्यहं तु प्रबोद्धव्यं पूर्वमेवोदयाद्रवे: ।<br>विधाय कृष्णस्मरणं कार्य: शौचविधिस्तत: ।।४९।।",
    gujarati:
      "અને અમારા સત્સંગી, તેમણે નિત્ય સૂર્ય ઊગ્યાથી પ્રથમ જ જાગવું અને શ્રીકૃષ્ણ ભગવાનનું સ્મરણ કરીને પછી શૌચવિધિ કરવા જવું. ।।૪૯।।",
  },
  {
    number: 50,
    sanskrit:
      "उपविश्यैव चैकत्र कर्तव्यं दन्तधावनम्‌ ।<br>स्नात्वा शुच्यम्बुना धौते परिधार्ये च वाससी ।।५०।।",
    gujarati:
      "અને પછી એક સ્થાનને વિષે બેસીને દાતણ કરવું અને પછી પવિત્ર જળે કરીને સ્નાન કરીને પછી ધોયેલું વસ્ત્ર એક પહેરવું અને એક ઓઢવું. ।।૫૦।।",
  },
  {
    number: 51,
    sanskrit:
      "उपविश्य तत: शुद्ध आसने शुचिभूतले ।<br>असङ्कीर्ण उपस्पृश्यं प्राङ्‌मुखं वोत्तरामुखम्‌ ।।५१।।",
    gujarati:
      "અને ત્યાર પછી પવિત્ર પૃથ્વીને વિષે પાથર્યું અને શુદ્ધ ને કોઈ બીજા આસનને અડ્યું ન હોય અને જે ઉપર સારી પેઠે બેસાય એવું જે આસન તેને વિષે પૂર્વમુખે અથવા ઉત્તરમુખે બેસીને આચમન કરવું. ।।૫૧।।",
  },
  {
    number: 52,
    sanskrit:
      "कर्तव्यमूर्ध्वपुण्ड्रं च पुम्भिरेव सचन्द्रकम्‌ ।<br>कार्य: सधवानारीभिर्भाले कुङ्कुमचन्द्रक: ।।५२।।",
    gujarati:
      "અને પછી સત્સંગી પુરુષમાત્રને ચાંદલે સહિત ઊર્ધ્વપુંડ્ર તિલક કરવું અને સુવાસિની જે સ્ત્રીઓ તેમણે તો  પોતાના ભालને વિષે કુંકુમનો ચાંદલો કરવો. ।।૫૨।।",
  },
  {
    number: 66,
    sanskrit:
      "यादृशैर्यो गुणैर्युक्तस्तादृशे स तु कर्मणि ।<br>योजनीयो विचार्यैव नान्यथा तु कदाचन ।।६६।।",
    gujarati:
      "અને જે મનુષ્ય જેવા ગુણે કરીને યુક્ત હોય તે મનુષ્યને તેવા કાર્યને વિષે વિચારીને જ પ્રેરવો પણ જે કાર્યને વિષે જે યોગ્ય ન હોય તે કાર્યને વિષે તેને કયારેય ન પ્રેરવો. ।।૬૬।।",
  },
  {
    number: 67,
    sanskrit:
      "अन्नवस्त्रादिभि: सर्वे स्वकीया: परिचारका: ।<br>सम्भावनीया: सततं यथायोग्यं यथाधनम्‌ ।।६७।।",
    gujarati:
      "અને  પોતાના જે સેવક હોય તે સર્વની  પોતાના સામર્થ્ય પ્રમાણે અન્નવસ્ત્રાદિકે કરીને યથાયોગ્ય સંભાવના નિરંતર રાખવી. ।।૬૭।।",
  },
  {
    number: 68,
    sanskrit:
      "याद्दग्गुणो य: पुरुषस्तादृशा वचनेन स: ।<br>देशकालानुसारेण भाषणीयो न चान्यथा ।।६८।।",
    gujarati:
      "અને જે પુરુષ જેવા ગુણવાળો હોય તે પુરુષને તેવા વચને કરીને દેશકાળાનુસારે યથાયોગ્ય બોલાવવો પણ એથી બીજી રીતે ન બોલાવવો. ।।૬૮।।",
  },
  {
    number: 69,
    sanskrit:
      "गुरुभूपालवर्षिष्ठत्यागिविद्वत्तपस्विनाम्‌ ।<br>अभ्युत्थानादिना कार्य: सन्मानो विनयान्वितै: ।।६९।।",
    gujarati:
      "અને વિનયે કરીને યુક્ત એવા જે અમારા આશ્રિત સત્સંગી તેમણે ગુરુ, રાજા, અતિ વૃદ્ધ, ત્યાગી, વિદ્વાન્‌ અને તપસ્વી એ છ જણા આવે ત્યારે સન્મુખ ઊઠવું તથા આસન આપવું તથા મધુર વચને બોલાવવું ઈત્યાદિક ક્રિયાએ કરીને એમનું સન્માન કરવું. ।।૬૯।।",
  },
  {
    number: 70,
    sanskrit:
      "नोरौ कृत्वा पादमेकं गुरुदेवनृपान्तिके ।<br>उपवेश्यं सभायां च जानू बद्धवा न वाससा ।।७०।।",
    gujarati:
      "અને ગુરુ, દેવ ને રાજા એમને સમીપે તથા સભાને વિષે પગ ઉપર પગ ચઢાવીને ન બેસવું तथा વસ્ત્રે કરીને ઢીંચણને બાંધીને ન બેસવું. ।।૭૦।।",
  },
  {
    number: 71,
    sanskrit:
      "विवादो नैव कर्तव्य: स्वाचार्येण सह क्वचित्‌ ।<br>पूज्योऽन्नधनवस्त्राद्यैर्यथाशक्ति स चाखिलै: ।।७१।।",
    gujarati:
      "અને અમારા આશ્રિત જે સર્વે સત્સંગી તેમણે  પોતાના આચાર્ય સંગાથે કયારેય પણ વિવાદ ન કરવો અને  પોતાના સામર્થ્ય પ્રમાણે અન્ન, ધન, વસ્ત્રાદિકે કરીને તે  પોતાના આચાર્યને પૂજવા. ।।૭૧।।",
  },
  {
    number: 72,
    sanskrit:
      "तमायान्तं निशम्याशु प्रत्युद्‌गन्तव्यमादरात्‌ ।<br>तस्मिन्‌ यात्यनुगम्यं च ग्रामान्तावधिं मच्छ्रितै: ।।७२।।",
    gujarati:
      "અમારા જે આશ્રિતજન, તેમણે  પોતાના આચાર્યને આવતા સાંભળીને આદર થકી તત્કાળ સન્મુખ જવું અને તે આચાર્ય  પોતાના ગામથી પાછા પધારે ત્યારે ગામની ભાગોળ સુધી વળાવવા જવું. ।।૭૨।।",
  },
  {
    number: 75,
    sanskrit:
      "गुह्यवार्ता तु कस्यापि प्रकाश्या नैव कुत्रचित्‌ ।<br>समदृष्टया न कार्यश्च यथार्हार्चाव्यतिक्रम: ।।७५।।",
    gujarati:
      "અને કોઈની પણ જે ગુહ્યવાર્તા તે તો કોઈ ઠેકાણે પણ પ્રકાશ કરવી જ નહિ ને જે જીવનું જેવી રીતે સન્માન કરવું ઘટતું હોય તેનું તેવી રીતે જ સન્માન કરવું પણ સમદૃષ્ટિએ કરીને એ મર્યાદાનું ઉલ્લંઘન કરવું નહિ. ।।૭૫।।",
  },
  {
    number: 79,
    sanskrit:
      "एकादशीनां सर्वासां कर्तव्यं व्रतमादरात्‌ ।<br>कृष्णजन्मदिनानां च शिवरात्रेश्च सोत्सवम्‌ ।।७९।।",
    gujarati:
      "અને સર્વ જે એકાદશીઓ તેમનું વ્રત જે તે આદર થકી કરવું તથા શ્રીકૃષ્ણ ભગવાનના જે જન્માષ્ટમી આદિક જન્મદિવસ તેમનું વ્રત આદર થકી કરવું તથા શિવરાત્રિનું વ્રત જે તે આદર થકી કરવું અને તે વ્રતના દિવસને વિષે મોટા ઉત્સવ કરવા. ।।૭૯।।",
  },
  {
    number: 86,
    sanskrit:
      "रवेरिन्दोश्चोपरागे जायमानेऽपरा: क्रिया: ।<br>हित्वाशु शुचिभि: सर्वै: कार्य: कृष्णमनोर्जप: ।।८६।।",
    gujarati:
      "અને સૂર્યનું ને ચંદ્રમાનું ગ્રહણ થયે સતે અમારા જે સર્વે સત્સંગી તેમણે બીજી સર્વે ક્રિયાનો તત્કાળ ત્યાગ કરીને પવિત્ર થઈને શ્રીકૃષ્ણ ભગવાનના મંત્રનો જપ કરવો. ।।૮૬।।",
  },
  {
    number: 87,
    sanskrit:
      "जातायामथ तन्मुक्तौ कृत्वा स्नानं सचेलकम्‌ ।<br>देयं दानं गृहिजनै: शक्त्याऽन्यैस्त्वर्च्य ईश्वर: ।।८७।।",
    gujarati:
      "અને તે ગ્રહણ મુકાઈ રહ્યા પછી વસ્ત્રે સહિત સ્નાન કરીને જે અમારા ગૃહસ્થ સત્સંગી હોય તેમણે  પોતાના સામર્થ્ય પ્રમાણે દાન કરવું અને જે ત્યાગી હોય તેમણે ભગવાનની પૂજા કરવી. ।।૮૭।।",
  },
  {
    number: 114,
    sanskrit:
      "गुणिनां गुणवत्ताया ज्ञेयं ह्येतत्‌ परं फलम्‌ ।<br>कृष्णे भक्तिश्च सत्सङ्गोऽन्यथा यान्ति विदोऽप्यध: ।।११४।।",
    gujarati:
      "અને વિદ્યાદિક ગુણવાળા જે પુરુષ તેમના ગુણવાન પણાનું એ જ પરમ ફળ જાણવું. કયું તો જે શ્રીકૃષ્ણ ભગવાનને વિષે ભક્તિ કરવી ને સત્સંગ કરવો અને એમ ભક્તિ ને સત્સંગ એ બે વિના તો વિદ્વાન હોય તે પણ અધોગતિને પામે છે. ।।૧૧૪।।",
  },
  {
    number: 116,
    sanskrit:
      "निजात्मानं ब्रह्मरू पं देहत्रयविलक्षणम्‌ ।<br>विभाव्य तेन कर्तव्या भक्ति: कृष्णस्य सर्वदा ।।११६।।",
    gujarati:
      "અને સ્થૂળ, સૂક્ષ્મ અને કારણ એ જે ત્રણ દેહ તે થકી વિલક્ષણ એવો જે  પોતાનો જીવાત્મા તેને બ્રહ્મરૂપની ભાવના કરીને પછી તે બ્રહ્મરૂપે કરીને શ્રીકૃષ્ણ ભગવાનની ભક્તિ જે તે સર્વકાળને વિષે કરવી. ।।૧૧૬।।",
  },
  {
    number: 121,
    sanskrit:
      "मतं विशिष्टाद्वैतं मे गोलोको धाम चेप्सितम्‌ ।<br>तत्र ब्रह्मात्मना कृष्णसेवा मुक्तिश्च गम्यताम्‌ ।।१२१।।",
    gujarati:
      "અને અમારો જે મત તે વિશિષ્ટાદ્વૈત છે એમ જાણવું અને અમને પ્રિય એવું જે ધામ તે ગોલોક છે એમ જાણવું અને તે ધામને વિષે બ્રહ્મરૂપે કરીને જે શ્રીકૃષ્ણ ભગવાનની સેવા કરવી તે અમે મુક્તિ માની છે એમ જાણવું. ।।૧૨૧।।",
  },
  {
    number: 135,
    sanskrit:
      "गृहाख्याश्रमिणो ये स्यु: पुरुषा मदुपाश्रिता: ।<br>स्वासन्नसम्बन्धहीना न स्पृश्या विधवाश्च तै: ।।१३५।।",
    gujarati:
      "હવે ગૃહસ્થાશ્રમીના જે વિશેષ ધર્મ તે કહીએ છીએ. અમારે આશ્રિત જે ગૃહસ્થાશ્રમી પુરુષ તેમણે  પોતાના સમીપ સંબંધ વિનાની જે વિધવા સ્ત્રીઓ તેમનો સ્પર્શ ન કરવો. ।।૧૩૫।।",
  },
  {
    number: 136,
    sanskrit:
      "मात्रा स्वस्रा दुहित्रा वा विजने तु वय:स्थया ।<br>अनापदि न तै: स्थेयं कार्यं दानं न योषित: ।।१३६।।",
    gujarati:
      "અને તે ગૃહસ્થાશ્રમી પુરુષ તેમણે યુવાન અવસ્થાએ યુક્ત એવી જે  પોતાની મા, બેન અને દીકરી તે સંગાથે પણ આપત્કાળ વિના એકાંતસ્થળને વિષે ન રહેવું અને  પોતાની સ્ત્રીનું દાન કોઈને ન કરવું. ।।૧૩૬।।",
  },
  {
    number: 137,
    sanskrit:
      "प्रसङ्गो व्यवहारेण यस्या: केनापि भूपते: ।<br>भवेत्तस्या: स्त्रिया: कार्य: प्रसङ्गो नैव सर्वथा ।।१३७।।",
    gujarati:
      "અને જે સ્ત્રીને કોઈ પ્રકારના વ્યવહારે કરીને રાજાનો પ્રસંગ હોય તેવી સ્ત્રીનો જે પ્રસંગ તે કોઈ પ્રકારે પણ ન કરવો. ।।૧૩૭।।",
  },
  {
    number: 139,
    sanskrit:
      "यावज्जीवं च शुश्रूषा कार्या मातु: पितुर्गुरो: ।<br>रोगार्तस्य मनुष्यस्य यथाशक्ति च मामकै: ।।१३९।।",
    gujarati:
      "અને અમારા આશ્રિત જે ગૃહસ્થ તેમણે માતા પિતા અને ગુરુ તથા રોગાતુર એવા જે કોઈ મનુષ્ય તેમની જે સેવા તે જીવનપર્યંત  પોતાના સામર્થ્ય પ્રમાણે કરવી. ।।૧૩૯।।",
  },
  {
    number: 141,
    sanskrit:
      "यथाशक्ति यथाकालं सङ्ग्रहोऽन्नधनस्य तै: ।<br>यावद्‌व्ययं च कर्तव्य: पशुमद्‌भिस्तृणस्य च ।।१४१।।",
    gujarati:
      "અને તે ગૃહસ્થ સત્સંગી તેમણે  પોતાના સામર્થ્ય પ્રમાણે સમયને અનુસરીને જેટલો  પોતાના ઘરમાં વરો હોય તેટલા અન્ન દ્રવ્યનો સંગ્રહ જે તે કરવો અને જેના ઘરમાં પશુ હોય એવા જે ગૃહસ્થ તેમણે  પોતાના સામર્થ્ય પ્રમાણે ચાર્યપૂળાનો સંગ્રહ કરવો. ।।૧૪૧।।",
  },
  {
    number: 143,
    sanskrit:
      "ससाक्ष्यमन्तरा लेखं पुत्रमित्रादिनाऽपि च ।<br>भूवित्तदानादानाभ्यां व्यवहार्यं न कर्हिचित्‌ ।।१४३।।",
    gujarati:
      "અને સાક્ષીએ સહિત લખત કર્યા વિના તો  પોતાના પુત્ર અને મિત્રાદિક સાથે પણ પૃથ્વી ને ધનના લેણદેણે કરીને વ્યવહાર જેતે કયારેય ન કરવો. ।।૧૪૩।।",
  },
  {
    number: 145,
    sanskrit:
      "आयद्रव्यानुसारेण व्यय: कार्यो हि सर्वदा ।<br>अन्यथा तु महद्‌दु:खं भवेदित्यवधार्यताम्‌ ।।१४५।।",
    gujarati:
      "અને  પોતાની ઉપજનું જે દ્રવ્ય તેને અનુસારે નિરંતર ખરચ કરવો પણ તે ઉપરાંત ન કરવો અને જે ઉપજ કરતાં વધારે ખરચ કરે છે તેને મોટું દુઃખ થાય છે; એમ સર્વે ગૃહસ્થોએ મનમાં જાણવું. ।।૧૪૫।।",
  },
  {
    number: 146,
    sanskrit:
      "द्रव्यस्यायो भवेद्यावान्‌ व्ययो वा व्यावहारिके ।<br>तौ संस्मृत्य स्वयं लेख्यौ स्वक्षरै: प्रतिवासरम्‌ ।।१४६।।",
    gujarati:
      "અને  પોતાના વ્યવહાર કાર્યને વિષે જેટલા ધનની ઉપજ હોય તથા જેટલો ખરચ હોય તે બેયને સંભારીને નિત્યપ્રત્યે રૂડા અક્ષરે કરીને  પોતે તેનું નામું લખવું.।।૧૪૬।।",
  },
  {
    number: 147,
    sanskrit:
      "निजवृत्त्युद्यमप्राप्तधनधान्यादितश्च तै: ।<br>अर्प्यो दशांश: कृष्णाय विंशोंऽशस्त्विह दुर्बलै: ।।१४७।।",
    gujarati:
      "અને તે ગૃહસ્થાશ્રમી સત્સંગી તેમણે  પોતાની જે વૃત્તિ અને ઉદ્યમ તે થકી પામ્યું જે ધન ધાન્યાદિક તે થકી દશમો ભાગ કાઢીને શ્રીકૃષ્ણભગવાનને અર્પણ કરવો અને જે વ્યવહારે દુર્બળ હોય તેમણે વીસમો ભાગ અર્પણ કરવો. ।।૧૪૭।।",
  },
  {
    number: 150,
    sanskrit:
      "स्वाचार्यान्न ऋणं ग्राह्यं श्रीकृष्णस्य च मन्दिरात्‌ ।<br>ताभ्यां स्वव्यवहारार्थं पात्रभूषांशुकादि च ।।१५०।।",
    gujarati:
      "અને  પોતાના જે આચાર્ય તે થકી તથા શ્રીકૃષ્ણ ભગવાનના જે મંદિર તે થકી કરજ ન કાઢવું અને વળી તે  પોતાના આચાર્ય થકી અને શ્રીકૃષ્ણના મંદિર થકી  પોતાના વ્યવહારને અર્થે પાત્ર, ઘરેણાં અને વસ્ત્રાદિક જે વસ્તુ તે માગી લાવવા નહીં. ।।૧૫૦।।",
  },
  {
    number: 151,
    sanskrit:
      "श्रीकृष्णगुरुसाधूनां दर्शनार्थं गतौ पथि ।<br>तत्स्थानेषु च न ग्राह्यं परान्नं निजपुण्यहृत्‌ ।।१५१।।",
    gujarati:
      "અને શ્રીકૃષ્ણ ભગવાન તથા  પોતાના ગુરુ તથા સાધુ એમના દર્શન કરવાને અર્થે ગયે સતે માર્ગને વિષે પારકું અન્ન ખાવું નહિ તથા શ્રીકૃષ્ણ ભગવાન તથા  પોતાના ગુરુ તથા સાધુ તેમનાં જે સ્થાનક તેમને વિષે પણ પારકું અન્ન ખાવું નહિ; કેમ જે તે પારકું અન્ન તો  પોતાના પુણ્યને હરી લે એવું છે; માટે  પોતાની ગાંઠનું ખરચ ખાવું. ।।૧૫૧।।",
  },
  {
    number: 152,
    sanskrit:
      "प्रतिज्ञातं धनं देयं यत्स्यात्तत्‌ कर्मकारिणे ।<br>न गोप्यमृणशुद्धयादि व्यवहार्यं न दुर्जनै: ।।१५२।।",
    gujarati:
      "અને  પોતાનું કામકાજ કરવા તેડયા જે મજૂર તેમને જેટલું ધન અથવા ધાન્ય દીધાનું કહ્યું હોય તે પ્રમાણે જ આપવું પણ તેમાંથી ઓછું ન આપવું અને પોતા પાસે કોઈ કરજ માગતો હોય અને તે કરજ દઈ ચૂકયા હોઈએ તે વાતને છાની ન રાખવી તથા  પોતાનો વંશ તથા કન્યાદાન તે પણ છાનું ન રાખવું અને દુષ્ટ એવા જે જન તેમની સાથે વ્યવહાર ન કરવો. ।।૧૫૨।।",
  },
  {
    number: 153,
    sanskrit:
      "दुष्कालस्य रिपूणां वा नृपस्योपद्रवेण वा ।<br>लज्जाधनप्राणनाश: प्राप्त: स्याद्यत्र सर्वथा ।।१५३।।",
    gujarati:
      "અને જે ઠેકાણે  પોતે રહેતા હોઈએ તે ઠેકાણે કોઈક કઠણ ભૂંડો કાળ અથવા શત્રુ અથવા રાજા તેમના ઉપદ્રવે કરીને સર્વ પ્રકારે  પોતાની લાજ જતી હોય કે ધનનો નાશ થતો હોય કે  પોતાના પ્રાણનો નાશ થતો હોય. ।।૧૫૩।।",
  },
  {
    number: 154,
    sanskrit:
      "मूलदेशोऽपि स स्वेषां सद्य एव विचक्षणै: ।<br>त्याज्यो मदाश्रितै: स्थेयं गत्वा देशान्तरं सुखम्‌ ।।१५४।।",
    gujarati:
      "અને તે જો  પોતાના મૂળ ગરાસનું તથા વતનનું ગામ હોય તો પણ તેનો વિવેકી એવા જે અમારા સત્સંગી ગૃહસ્થ તેમણે તત્કાળો ત્યાગ કરી દેવો અને જ્યાં ઉપદ્રવ ન હોય તેવો જે બીજો દેશ તે પ્રત્યે જઈને સુખેથી રહેવું. ।।૧૫૪।।",
  },
  {
    number: 159,
    sanskrit:
      "सभर्तृकाभिर्नारीभि: सेव्य: स्वपतिरीशवत्‌ ।<br>अन्धो रोगी दरिद्रो वा षण्ढो वाच्यं न दुर्वच: ।।१५९।।",
    gujarati:
      "હવે સુવાસિની બાઈઓના વિશેષ ધર્મ કહીએ છીએ. અમારે આશ્રિત જે સુવાસિની બાઈઓ તેમણે  પોતાનો પતિ અંધ હોય, રોગી હોય, દરિદ્રી હોય, નપુંસક હોય તો પણ તેને ઈશ્વરની પેઠે સેવવો અને તે પતિ પ્રત્યે કટુ વચન ન બોલવું. ।।૧૫૯।।",
  },
  {
    number: 160,
    sanskrit:
      "रू पयौवनयुक्तस्य गुणिनोऽन्यनरस्य तु ।<br>प्रसङ्गो नैव कर्तव्यस्ताभि: साहजिकोऽपि च ।।१६०।।",
    gujarati:
      "અને સુવાસિની સ્ત્રીઓ તેમણે રૂપ ને યૌવન તેને યુક્ત અને ગુણવાન એવો જે અન્ય પુરુષ તેનો પ્રસંગ સહજ સ્વભાવે પણ ન કરવો. ।।૧૬૦।।",
  },
  {
    number: 205,
    sanskrit:
      "इमामेव ततो नित्यमनुसृत्य ममाश्रितै: ।<br>यतात्मभिर्वर्तितव्यं न तु स्वैरं कदाचन ।।२०५।।",
    gujarati:
      "એ હેતુ માટે અમારા આશ્રિત જે સત્સંગી તેમણે સાવધાનપણે કરીને નિત્ય પ્રત્યે આ શિક્ષાપત્રીને અનુસરીને જ વર્તવું પણ  પોતાના મનને જાણે તો કયારેય ન વર્તવું. ।।૨૦૫।।",
  },
  {
    number: 207,
    sanskrit:
      "नेत्थं य आचरिष्यन्ति ते त्वस्मत्सम्प्रदायत: ।<br>बहिर्भूता इति ज्ञेयं स्त्रीपुंसै: साम्प्रदायिकै: ।।२०७।।",
    gujarati:
      "અને જે બાઈ ભાઈ આ શિક્ષાપત્રી પ્રમાણે નહિ વર્તે તે તો અમારા સંપ્રદાય થકી બાહેર છે. એમ અમારા સંપ્રદાયવાળા સ્ત્રી પુરુષ તેમણે જાણવું. ।।૨૦૭।।",
  },
];
